import React from 'react'
import { Dialog, Button, CardContent, Typography, Box } from '@material-ui/core'

const AllowLiveDialog = ({ open, close, requestUser }) => {
  return (
    <Dialog open={open} disableBackdropClick>
      <CardContent>
        <Typography>
          {requestUser} would like to start streaming. Can they take over?
        </Typography>
      </CardContent>
      <Box
        display="flex"
        justifyContent="space-around"
        style={{ marginBottom: '16px' }}
      >
        <Button variant="contained" onClick={() => close(false)}>
          No
        </Button>
        <Button variant="contained" onClick={() => close(true)} color="primary">
          Yes
        </Button>
      </Box>
    </Dialog>
  )
}

export default AllowLiveDialog



// WEBPACK FOOTER //
// ./src/pages/Stream/allowLiveDialog.jsx